import { AccessPolicy } from '@chr/online-shared-microsite-core/types';

export enum EntityTypeIds {
  customer = 2,
  supplier = 4,
}

export const getUserCustomerCodes = (userAccessPolicies: AccessPolicy[]): string[] => userAccessPolicies?.reduce((codes, policy) => {
  if (policy.entity.entityTypeID === EntityTypeIds.customer) {
    codes.push(policy.entity.code);
  }
  return codes;
}, []);

export const getUserPoPartyCode = (poCustomerCode: string, userAccessPolicies: AccessPolicy[]) => {
  const supplierPartyCode = userAccessPolicies.find((userAccessPolicy) => userAccessPolicy.entity?.entityTypeID === EntityTypeIds.supplier)?.entity?.code;
  if (supplierPartyCode) {
    return supplierPartyCode;
  }
  return getUserCustomerCodes(userAccessPolicies).find(c => c === poCustomerCode);
};

export const userHasPermission = (permissionName: number, userAccessPolicies: AccessPolicy[]): boolean => userAccessPolicies?.some(
  (policy) => policy.permissionIds?.includes(permissionName),
);
